import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';
import { TabStack, TabTitle } from '../style/reportCommonStyle';
import { ArrowForwardOutlinedIcon } from '../../constants/images';

const FormTitle = (props) => {
  const {
    media,
    currentTab,
    mainColor,
    setCurrentTab,
  } = props;

  return (
    <>
      <Typography variant="h2" align="center">
        <FormattedMessage id="createData.header.title" values={{ media: media }} />
      </Typography>

      <TabStack variant='center-center'>
        <TabTitle
          tab={currentTab}
          color={mainColor}
          type={'reportData'}
          onClick={() => setCurrentTab(0)}
        >
          <FormattedMessage id="common.title.setReport" />
        </TabTitle>
        <ArrowForwardOutlinedIcon sx={{ ml: 2, mr: 2 }} />
        <TabTitle
          tab={currentTab}
          color={mainColor}
          type={'sendData'}
          onClick={() => { setCurrentTab(1) }}
        >
          <FormattedMessage id="common.title.setMail" />
        </TabTitle>
      </TabStack>
    </>
  )
}

export default FormTitle;